import React from 'react';
import './App.css';
import Faucet from './Faucet';
import Footer from './Footer';

function App() {
    return (
        <div className="App">
            <Faucet />
            <Footer />
        </div>
    );
}

export default App;
